// extracted by mini-css-extract-plugin
module.exports = {"hide":"header2_hide__3D3cl","div1":"header2_div1__1qT_j","list":"header2_list__3qr1Z","anch":"header2_anch__pTeoV","anch1":"header2_anch1__I6YNk","div2":"header2_div2__5jFig"};